/**
* Composition for Popups
*/
export default function () {
  const { $i18n: i18n } = useNuxtApp()
  const confirm = useConfirm()

  /**
  * Component Panel Options
  * @params params
  */
  const drawerOptions = useState('drawerOptions', () => { 
    return {
      forms: {}
    }
  })

  /**
  * Custom Confirm Ref
  */
  const confirmPopupRef = useState('confirmPopupRef', () => { 
    return {}
  })

  /**
  * Custom Confirm
  * 
  * Example:
  * const { confirmOptions } = usePopups()
  * 
    @click="confirmOptions({
      message: $t('deleteCampaign'),
      accept: () => { 
        useDeleteCampaign({
          id: campaign.id
        })
      }
    })"

    @click="confirmOptions({
      message: $t('copyCampaign'),
      rejectProps: {
        label: $t('copyCampaignWithRecipients'),
        severity: 'secondary',
        outlined: true
      },
      acceptProps: {
        label: $t('copyCampaignWithoutRecipients'),
        severity: 'contrast',
        outlined: true
      },
      reject: () => { 
        useCopyCampaign({
          id: campaign.id
        })
      },
      accept: () => { 
        useCopyAllCampaign({
          id: campaign.id
        })
      }
    })"
  */
  const confirmOptions = (options = {}) => { 
    confirm.require({
      onShow: options.onShow,
      target: options.target,
      header: options.header ? options.header : i18n?.t('confirmation'),
      message: options.message ? options.message : i18n?.t('confirmMessage'),
      position: options.position ? options.position : 'center',
      icon: options.icon ? options.icon : 'icon icon-c-warning',
      rejectProps: {
        label: i18n?.t('notNow'),
        severity: 'secondary',
        outlined: true,
        ...(options.rejectProps && typeof options.rejectProps === 'object' ? options.rejectProps : {}),
        ...(options.rejectProps === false || options.rejectClass ? { class: options.rejectClass || 'hidden' } : {})
      },
      acceptProps:
        options.acceptProps
          ? options.acceptProps
          : {
            label: i18n?.t('confirm'),
            severity: 'primary'
          },
      reject:
        options.reject
          ? options.reject
          : () => { 

          },
      accept:
        options.accept
          ? options.accept
          : () => { 

          }
    })
  }
 
  /**
  * Not Overflow
  */
  const popupNotOverflow = useState('popupNotOverflow', () => false)

  /*
  * Open PubbleChat
  */
  const hidePubbleChat = () => { 
    if (document?.querySelector('.pubble-cw-shadow')?.classList?.contains('pubble-show') || document?.querySelector('.pubble-iframe.pubble-iframe-expanded')) {
      document?.querySelector('.pubble-cw-contactbot')?.click()
    }
  }
  
  /**
  * Return Object
  */
  return {
    drawerOptions,
    confirmPopupRef,
    confirmOptions,
    popupNotOverflow,

    hidePubbleChat
  }
}
